import { memo, ReactElement, useCallback } from 'react';
import { FilterChipProps } from './common';
import { BinaryChoiceFilterProps } from '../Primitives/BinaryChoiceFilter';
import { BaseFilterChip } from './BaseFilterChip';
import { useTranslation } from 'react-i18next';

export const BinaryChoiceFilterChip = memo(function ({
  displayName,
  filterKey,
  onValueChange,
  trueOptionIcon = undefined,
  falseOptionIcon = undefined,
  value,
}: FilterChipProps<BinaryChoiceFilterProps>): ReactElement {
  const { t } = useTranslation();

  const handleRemove = useCallback(
    function (): void {
      if (onValueChange) {
        onValueChange(undefined);
      }
    },
    [onValueChange]
  );

  if (!value || value.eq === undefined) return <></>;

  const filterValue = `filter.${filterKey}.${value.eq}`;
  const genericValue = `common.${value.eq ? 'yes' : 'no'}`;

  const icon = value.eq ? trueOptionIcon : falseOptionIcon;

  return (
    <>
      <BaseFilterChip icon={icon} onRemove={handleRemove}>
        {t(displayName)}: {t([filterValue, genericValue])}
      </BaseFilterChip>
    </>
  );
});
